/**
 * Auxilio Travel - Main Application Component
 * AI-Powered Travel Planning Platform
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/config';

// Layout components
import { MainLayout } from './components/layout/MainLayout';

// Pages
import { LandingPage } from './pages/LandingPage';
import { Dashboard } from './pages/Dashboard';
import { TravelGlossary } from './pages/TravelGlossary';
import { TravelQuestions } from './pages/TravelQuestions';
import { TravelCalculators } from './pages/TravelCalculators';
import { DestinationExplorer } from './pages/DestinationExplorer';
import { ItineraryBuilder } from './pages/ItineraryBuilder';
import { WeatherIntelligence } from './pages/WeatherIntelligence';
import { FlightRouteExplorer } from './pages/FlightRouteExplorer';
import { AccommodationGuide } from './pages/AccommodationGuide';
import { GroundTransportGuide } from './pages/GroundTransportGuide';
import { CulturalIntelligenceHub } from './pages/CulturalIntelligenceHub';
import { PhraseBook } from './pages/PhraseBook';
import { CuisineIntelligence } from './pages/CuisineIntelligence';

const App: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />

          {/* Protected Routes */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/travel-glossary" element={<TravelGlossary />} />
            <Route path="/ask-questions" element={<TravelQuestions />} />
            <Route path="/calculators" element={<TravelCalculators />} />
            <Route path="/destinations" element={<DestinationExplorer />} />
            <Route path="/itinerary" element={<ItineraryBuilder />} />
            <Route path="/weather" element={<WeatherIntelligence />} />
            <Route path="/flights" element={<FlightRouteExplorer />} />
            <Route path="/accommodations" element={<AccommodationGuide />} />
            <Route path="/transport" element={<GroundTransportGuide />} />
            <Route path="/cultural" element={<CulturalIntelligenceHub />} />
            <Route path="/phrasebook" element={<PhraseBook />} />
            <Route path="/cuisine" element={<CuisineIntelligence />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </I18nextProvider>
  );
};

export default App;
